import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { getRetailPrice, getSalePrice, getNetPrice } from 'dibs-selectors/dist/item';
import { getPriceAmountByCurrency } from 'dibs-selectors/dist/price';
import get from 'lodash.get';

function getPrice(selector, item, currency) {
    const amount = getPriceAmountByCurrency(selector(item))(currency);
    return <FormattedNumber value={amount} style="currency" currency={currency} />;
}

const ItemPrice = ({ currency, item }) => {
    const pricePerItem = get(item, 'canMultipleQuantityBePurchased');
    const { showOnHold, showRetail, showNet, showSale, showPUR, showSold } =
        get(item, 'pdpDisplayInfo.pricing') || {};

    let label;
    let price;

    if (!showSold && !showOnHold) {
        if (showSale) {
            price = getPrice(getSalePrice, item, currency) || 0;
            label = (
                <FormattedMessage id="portfolio.listView.sale_price" defaultMessage="Sale Price" />
            );
        } else if (showNet) {
            price = getPrice(getNetPrice, item, currency) || 0;
            label = (
                <FormattedMessage id="portfolio.listView.net_price" defaultMessage="Net Price" />
            );
        } else if (showRetail) {
            price = getPrice(getRetailPrice, item, currency) || 0;
            label = (
                <FormattedMessage id="portfolio.listView.list_price" defaultMessage="List Price" />
            );
        } else if (showPUR) {
            return (
                <FormattedMessage
                    id="portfolio.listView.price_upon_request"
                    defaultMessage="Price Upon Request"
                />
            );
        }
    } else {
        return (
            <FormattedMessage
                id="portfolio.listView.price_not_available"
                defaultMessage="Not Available"
            />
        );
    }

    return (
        <div>
            {pricePerItem ? (
                <FormattedMessage
                    id="portfolio.listView.per_item"
                    defaultMessage="{price} / item"
                    values={{ price }}
                />
            ) : (
                price
            )}
            {label ? ' ' : ''}
            {label}
        </div>
    );
};

ItemPrice.propTypes = {
    currency: PropTypes.string,
    item: PropTypes.shape({
        canMultipleQuantityBePurchased: PropTypes.bool,
        isSold: PropTypes.bool,
        vertical: PropTypes.string,
        pricing: PropTypes.object,
        pdpDisplayInfo: PropTypes.object,
    }),
};

export default createFragmentContainer(ItemPrice, {
    item: graphql`
        fragment ItemPrice_item on Item {
            canMultipleQuantityBePurchased
            vertical
            pdpDisplayInfo: displayInfo(buyerId: $userId, page: pdp) @include(if: $hasUserId) {
                pricing {
                    showRetail
                    showNet
                    showSale
                    showPUR
                    showSold
                    showOnHold
                }
            }
            pricing {
                totalAmount {
                    currency
                }
                prices {
                    amount {
                        amount
                        convertedAmountList {
                            amount
                            currency
                        }
                    }
                    pricePerPiece
                    hidePrice
                    negotiable
                    type
                    status
                }
            }
        }
    `,
});
